import React, { useState, useEffect } from "react";
import { useLocation, NavLink } from "react-router-dom";
import GoogleLoginComponent from "./googlebutton.component";

const Navbar = ({ cartItems, placeholder, handleChange }) => {
  // const [show, setShow] = useState(false);

  // const [dropdown, setDropdown] = useState(false);
  // const toggleOpen = () => setDropdown(!dropdown);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1250);
  useEffect(() => {
    window.addEventListener("resize", () => {
      const ismobile = window.innerWidth < 1250;
      if (ismobile !== isMobile) setIsMobile(ismobile);
    }, false);
  }, [isMobile]);

  const location = useLocation();

  return (

    <nav className="navbar navbar-light fixed-top order-header-navbar">
      <div className="container-fluid">
        <NavLink className="navbar-brand logo-text-img" exact aria-current="page" to="/">
          <img src='./../images/logo.png' alt="" width="40" height="40" className="d-inline-block align-middle" />
          Community Compassion Center
        </NavLink>

        {/* <Searchhead placeholder="Search Product" handelChange = {(e) => this.setState({searchField:e.target.value})}/> */}


        {/* <form className={`d-flexs search-box ${isMobile ? "col-md-12 col-sm-12 col-12 search-wrapper" : "search-bar"}`}>
          <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
                    <button className="btn btn-outline-success" type="submit">Search</button>

          {  location.pathname.includes("Product") && 
                    <div className="input-group">
                    <span className="input-group-text" id="basic-addon1"><i className="fas fa-search"></i></span>
                    <input type="search" className="form-control" key="random1"
                        // value={keyword}
                        placeholder={placeholder}
                        onChange={handleChange}/>
                    </div>
                  }
        </form> */}


        <div className="navbarItemsToRight">
          <nav className={`navbar navbar-icon-top navbar-expand-lg navbar-light header-nav ${isMobile ? "fixed-bottom header-footer-nav" : " "}`}>
            <div className="container-fluid">
              <ul className={`navbar-nav ms-auto mb-lg-0 ${isMobile ? "row align-items-start" : " "}`}>
                {/* <li className={`nav-item ${isMobile ? "col" : " "}`}>
                <NavLink className="nav-link" activeClassName="active" exact aria-current="page" to="/Events"
                  isActive={(match, location) => {
                    return location.pathname === '/Events' || location.pathname === '/';
                  }}
                >
                  <i className="fas fa-home"></i>
                  Home
                </NavLink>
              </li> */}
                <li className={`nav-item ${isMobile ? "col" : " "}`}>
                  <NavLink className="nav-link" activeClassName="active" exact aria-current="page" to="/Product">
                    <i className="fas fa-home"></i>
                    Products
                  </NavLink>
                </li>
                <li className={`nav-item ${isMobile ? "col" : " "}`}>
                  <NavLink className="nav-link" activeClassName="active" exact aria-current="page" to="/Orders">
                    <i className="fas fa-archive"></i>
                    Orders
                  </NavLink>
                </li>
                <li className={`nav-item ${isMobile ? "col" : " "}`}>
                  <NavLink className="nav-link" activeClassName="active" exact aria-current="page" to="/Cart">
                    <div type="button" className="position-relative">
                      <i className="fas fa-shopping-cart">
                        <span className="position-absolute top-0 cart-badge translate-middle badge rounded-pill bg-danger">
                          {cartItems?.length === 0 ? "" : cartItems?.length}
                        </span>
                      </i>
                      Cart
                    </div>
                  </NavLink>
                </li>
              </ul>
            </div>
          </nav>
        </div>


        <button className="navbar-toggler navbar-position-mobile navbar-toggle-btn" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="offcanvas offcanvas-end" tabindex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="offcanvasNavbarLabel"></h5>
            <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>
          <div className="offcanvas-body">
            <ul className="navbar-nav justify-content-end flex-grow-1">
              <li>
                <GoogleLoginComponent />

              </li>
              {/* <li className="nav-item">
                <NavLink className="nav-link" activeClassName="active" exact aria-current="page" to="/Events">
                  <i className="fas fa-calendar-week humbrger-menu-icon"></i> Events
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link " activeClassName="active" exact aria-current="page" to="/Product">
                  <i className="fas fa-shopping-basket humbrger-menu-icon"></i> Order Grocery
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link " activeClassName="active" exact aria-current="page" to="/orderhistory">
                  <i className="fas fa-history humbrger-menu-icon"></i> Order History
                </NavLink>
              </li> */}
            </ul>
          </div>
        </div>
      </div>

    </nav>
  )
}

export default Navbar;